'use strict';

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

var _reactBootstrap = require('react-bootstrap');

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

//require('moment/locale/cs');

var _components = {
	_$DateRange: {
		displayName: 'DateRange'
	}
};

function _wrapComponent(uniqueId) {
	return function (ReactClass) {
		return ReactClass;
	};
}

var React = require('react');
var classnames = require('classnames');
var DateRangePicker = require('react-bootstrap-daterangepicker');
var PureRenderMixin = require('react-addons-pure-render-mixin');
var Picker = _wrapComponent('_$DateRange')(React.createClass({ displayName: 'DateRange',

	mixins: [PureRenderMixin],

	getInitialState: function getInitialState() {
		return {
			value: this.fixValue(this.props.value)
		};
	},

	getDefaultProps: function getDefaultProps() {
		return {
			time: false
		};
	},

	fixValue: function fixValue(val) {
		if (val) {
			var start = _moment2['default'](val.startDate);
			var end = _moment2['default'](val.endDate);
			return {
				startDate: start,
				endDate: end
			};
		}
		return null;
	},

	componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
		this.setState({ value: this.fixValue(nextProps.value) });
	},

	getValue: function getValue() {
		return this.state.value;
	},

	renderFormGroup: function renderFormGroup(children) {
		var classes = {
			'form-group': false,
			'has-feedback': this.props.hasFeedback,
			'has-success': this.props.bsStyle === 'success',
			'has-warning': this.props.bsStyle === 'warning',
			'has-error': this.props.bsStyle === 'error'
		};
		classes[this.props.groupClassName] = this.props.groupClassName;

		return React.createElement("div", { className: classnames(classes) }, children);
	},

	renderError: function renderError() {
		return this.props.error ? React.createElement("span", { className: "error-block", key: "error" }, this.props.error) : null;
	},

	renderWrapper: function renderWrapper(children) {
		return this.props.wrapperClassName ? React.createElement("div", { className: this.props.wrapperClassName, key: "wrapper" }, children) : children;
	},

	onApply: function onApply(e, picker) {
		var _this = this;

		var value = {
			startDate: picker.startDate,
			endDate: picker.endDate
		};
		this.setState({ value: value }, function () {
			return _this.handleChange();
		});
	},

	handleChange: function handleChange(e) {
		if (this.props.onChange) {
			this.props.onChange(this.state.value);
		}
		if (this.props.onBlur) {
			this.props.onBlur(this.state.value);
		}
	},

	onCancel: function onCancel(e, p) {
		var _this2 = this;

		this.setState({ value: null }, function () {
			return _this2.handleChange();
		});
	},

	render: function render() {

		_moment2['default'].locale('cs');
		var locale = {
			format: 'DD.MM.YYYY',
			separator: ' - ',
			applyLabel: 'OK',
			cancelLabel: 'Zrušit výběr',
			fromLabel: 'Od',
			toLabel: 'Do',
			weekLabel: 'T',
			customRangeLabel: 'Vlastní rozsah',
			daysOfWeek: _moment2['default'].weekdaysMin(),
			monthNames: _moment2['default'].monthsShort(),
			firstDay: _moment2['default'].localeData()._week.dow
		};

		var ranges = {
			'Dnes': [_moment2['default'](), _moment2['default']()],
			'Včera': [_moment2['default']().subtract(1, 'days'), _moment2['default']().subtract(1, 'days')],
			'Tento týden': [_moment2['default']().startOf('isoweek'), _moment2['default']()],
			'Tento měsíc': [_moment2['default']().startOf('month'), _moment2['default']().endOf('month')],
			'Minulý měsíc': [_moment2['default']().subtract(1, 'month').startOf('month'), _moment2['default']().subtract(1, 'month').endOf('month')]
		};

		var label = '';
		if (this.state.value) {
			var s = _moment2['default'](this.state.value.startDate);
			var start = s.format('D.M.');
			var e = _moment2['default'](this.state.value.endDate);
			var end = e.format('D.M.');
			label = start + ' - ' + end;
			if (s.format('D.M.YYYY') === e.format('D.M.YYYY')) {
				label = s.format('D.M.YYYY');
			}
		}

		//var { onBlur, ...other } = this.props;
		return this.renderFormGroup([this.renderWrapper([React.createElement(
			DateRangePicker,
			{ onApply: this.onApply, onCancel: this.onCancel, ranges: ranges,
				startDate: this.state.value ? this.state.value.startDate : _moment2['default'](),
				endDate: this.state.value ? this.state.value.endDate : _moment2['default'](),
				locale: locale, opens: this.props.opens },
			React.createElement(
				_reactBootstrap.Button,
				{ className: 'selected-date-range-btn', style: { width: '100%' } },
				React.createElement(
					'div',
					{ className: 'pull-left' },
					label
				),
				React.createElement(
					'div',
					{ className: 'pull-right' },
					React.createElement('span', { className: 'caret' })
				)
			)
		)]), this.renderError()]);
	}
}));

module.exports = Picker;


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Form/DateRange.js
 ** module id = 166
 ** module chunks = 2
 **/